import storage from 'src/services/storage';

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {EventsFeedItem[]} events
 */
export function insertEvents(state, events) {
  state.events = [...state.events, ...events];
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {number} height
 */
export function setActivityAreaHeight(state, height) {
  state.activityAreaHeight = height;
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {string} eventsCursor
 */
export function setEventsCursor(state, eventsCursor) {
  state.eventsCursor = eventsCursor;
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {[string, string]} dateRange
 */
export function setDateRangeFilter(state, dateRange) {
  state.dateRangeFilter = dateRange;
  storage.set('events/dateRangeFilter', JSON.stringify(dateRange));
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {[string, string]} driverKey
 */
export function setDriverFilter(state, driverKey) {
  state.driverFilter = driverKey;
  storage.set('events/driverFilter', driverKey);
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {EventsFeedItem[]} events
 */
export function setEvents(state, events) {
  state.events = events;
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {boolean} hasLoadedAll
 */
export function setHasLoadedAll(state, hasLoadedAll) {
  state.hasLoadedAll = hasLoadedAll;
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {boolean} didLoad
 */
export function setDidLoad(state, didLoad) {
  state.didLoad = didLoad;
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {boolean} isApplying
 */
export function setIsApplying(state, isApplying) {
  state.isApplying = isApplying;
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {boolean} isLoading
 */
export function setIsLoading(state, isLoading) {
  state.isLoading = isLoading;
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {boolean} isLoading
 */
export function setIsLoadingSingleEvent(state, isLoading) {
  state.isLoadingSingleEvent = isLoading;
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {import('src/types/events-feed').EventsFeedItem} event
 */
export function setSelectedEvent(state, event) {
  state.selectedEvent = event ? { ...event } : null;
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {import('src/types/events-feed').EventsFeedItem} event
 */
export function setSingleEvent(state, event) {
  state.singleEvent = event;
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {import('src/types/events-feed').EventType[]} types
 */
export function setTypeFilter(state, types) {
  state.typeFilter = types;
  storage.set('events/typeFilter', JSON.stringify(types));
}

/**
 * @param {import('src/types/events-store').EventsStoreState} state
 * @param {string} vehicleKey
 */
export function setVehicleFilter(state, vehicleKey) {
  state.vehicleFilter = vehicleKey;
  storage.set('events/vehicleFilter', vehicleKey);
}
